var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:_vm.customClass,attrs:{"color":_vm.statusObject ? _vm.statusObject.color : '',"text-color":_vm.statusObject ? _vm.statusObject.textcolor : '',"label":""}},[_vm._v(" "+_vm._s(_vm.statusObject ? _vm.statusObject.text : "")+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }